import { TS_SelectType } from 'Models/TravelSeller/Models/TS_SelectType';

export class SelectType extends TS_SelectType {}